module.exports = __webpack_public_path__ + "img/33.9b472460.jpg";